/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LngGnlSearchBody } from '../../models/lng-gnl-search-body';
import { LngStationGnlList } from '../../models/lng-station-gnl-list';
import { SortDirection } from '../../models/sort-direction';

export interface SearchGnlLng$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the station's name
 */
  sortFieldName?: 'NAME';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search GNL for LNG
     */
    body?: LngGnlSearchBody
}

export function searchGnlLng$Json(http: HttpClient, rootUrl: string, params?: SearchGnlLng$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LngStationGnlList>> {
  const rb = new RequestBuilder(rootUrl, searchGnlLng$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LngStationGnlList>;
    })
  );
}

searchGnlLng$Json.PATH = '/custom/lng/stations/gnl/search';
